var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',[_c('h2',[_vm._v("Course Registration")]),_c('v-data-table',{staticClass:"mt-2 elevation-2",attrs:{"headers":_vm.headers,"items":_vm.registrationEvents,"items-per-page":5,"dense":"","loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }